import Text from '@components/Text';
import styled from '@emotion/styled';
import { Trans } from 'react-i18next';

function OrderNote() {
    return (
        <Container >
            <NoteText color='var(--color-text-secondary)' size='label-lg' align='center'>
                <Trans ns="orderLog" i18nKey="note.pushNotification" components={{ br: <br /> }} />
            </NoteText>
        </Container>
    );
}

const Container = styled.div`
    background-color: var(--color-white);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-sm);
    margin: var(--spacing-4) var(--spacing-4) 0;
    padding: var(--spacing-4);
    width: calc(100% - var(--spacing-8));
`;

const NoteText = styled(Text)`
    line-height: 1.4;
`;

export default OrderNote;
